
import './summary.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import menuLayout from '../../directive/menu-layout';
import starRating from '../../directive/star-rating';
import doughnutTextInside from '../../directive/doughnut-text-inside';
import configurableChart from '../../directive/configurable-chart';

import stats from '../../service/stats';
import user from '../../service/user';
import email from '../../service/email';

import pickerFilter from '../../filter/picker';

import routing from './summary.routes';
import SummaryController from './summary.controller';

export default angular.module('page.summary', [
		uirouter,
		menuLayout,
		starRating,
		doughnutTextInside,
		configurableChart,
		stats,
		user,
		email,
		pickerFilter,
		'chart.js'
	])
	.config(routing)
	.controller('SummaryController', SummaryController)
	.name;



// WEBPACK FOOTER //
// ./src/page/summary/index.js